import { Navigate } from "react-router-dom";

import { AcceptInviteTeamPage } from "./accept-invite-team.page";
import { AcceptInviteWorkspacePage } from "./accept-invite-workspace.page";
import { LoginPage } from "./login.page";
import { PasswordForgotPage } from "./password-forgot.page";
import { PasswordResetPage } from "./password-reset.page";

export const authRoutes = (isAuthenticated: boolean) => [
  { path: "/login", element: isAuthenticated ? <Navigate to="/" replace /> : <LoginPage /> },
  {
    path: "/forgot-password",
    element: isAuthenticated ? <Navigate to="/" replace /> : <PasswordForgotPage />,
  },
  {
    path: "/reset-password",
    element: isAuthenticated ? <Navigate to="/" replace /> : <PasswordResetPage />,
  },
  { path: "/invitation/workspace", element: <AcceptInviteWorkspacePage /> },
  { path: "/invitation/team", element: <AcceptInviteTeamPage /> },
];
